import type { WretchError, WretchResponse } from "wretch";

/** A failed API call, carrying the backend's error body the way the helpers in errors.ts read it. */
export type ApiError = WretchError & {
  text?: string;
  json?: any;
};

/**
 * wretch error transformer, registered with `.customError(withErrorBody)` on every client that calls
 * our API. wretch 2 attached the response body to errors as `text` and `json`; wretch 3 no longer
 * does, so without this every check of the backend's error code (`error.json.error.code`) silently
 * fails. The body text also stays in `message`, as wretch 3 does when no transformer is set.
 */
export const withErrorBody = async (error: WretchError, response: WretchResponse): Promise<ApiError> => {
  const apiError: ApiError = error;
  try {
    const text = await response.text();
    if (text) {
      apiError.text = text;
      apiError.message = text;
    }
    apiError.json = JSON.parse(text);
  } catch {
    // empty or non-JSON body, e.g. a proxy error page: keep the status-only error
  }
  return apiError;
};
